export class Invite {
  id: string;
  status: string;
  sender: any;
  recipient: any;
  target: any;
  targetModel: string;
  community: any;
  createdAt: string;
  updatedAt: string;
}
